import { throttle } from 'lodash-es'


const ScrollResize = {
  data () {
    return {
      windowSize: {
        width: 0,
        height: 0,
      },
    }
  },
  methods: {
    handleScroll: function() {
      bus.$emit('window_scroll')
    },
    handleResize: function() {
      this.windowSize.width = window.innerWidth
      this.windowSize.height = window.innerHeight
      bus.$emit('window_resize', this.windowSize)
    }
  },
  created () {
    window.addEventListener('scroll', throttle(this.handleScroll, 50))
    window.addEventListener('resize', throttle(this.handleResize, 50))
  },
  mounted () {
    this.handleResize()
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
    window.removeEventListener('resize', this.handleResize)
  }
}

export default ScrollResize
